import { AutenticacionService } from './autenticacion.service';
import { ConstantsService } from './constants.service';
import { Http } from '@angular/http';
import { Injectable } from '@angular/core';

@Injectable()
export class SobreBlancoService {
  private apiURL: string;
  private service_url: string;

  constructor(private http: Http,
    private constantsServices: ConstantsService,
    private authService: AutenticacionService) {
    this.apiURL = constantsServices.apiURL;
    this.service_url = this.apiURL + '/sobre-blanco';
  }

  public obtenerTotales() {
    return this.http.get(this.service_url + '/totales', this.authService.getAuthHeaders());
  }

  public obtenerTotalesObra() {
    return this.http.get(this.service_url + '/totales-obra', this.authService.getAuthHeaders());
  }

  public obtenerBases() {
    return this.http.get(this.service_url + '/bases', this.authService.getAuthHeaders());
  }

  public guardarBases(bases) {
    return this.http.post(this.service_url + '/bases', { bases: bases }, this.authService.getAuthHeaders());
  }

  public guardarMovimiento(movimiento) {
    return this.http.post(this.service_url + '/movimientos', movimiento, this.authService.getAuthHeaders());
  }

  public obtenerMovimientos() {
    return this.http.get(this.service_url + '/movimientos', this.authService.getAuthHeaders());
  }

  public eliminarMovimiento(id) {
    return this.http.post(this.service_url + '/movimientos/eliminar', { id: id }, this.authService.getAuthHeaders());
  }

  public canSecurity() {
    return this.authService.canSecurity();
  }

  public activeSecurityModule(password) {
    const data = { password: password };
    return this.http.post(this.service_url + '/key', data, this.authService.getAuthHeaders());
  }
}



// WEBPACK FOOTER //
// ./src/app/services/sobre-blanco.service.ts